/**
 * Names typed into project, task and workspace fields never contain
 * whitespace: every whitespace character becomes a dash as the user types.
 * Pass `{ trimEnd: true }` on submit to drop the dashes a trailing space left.
 */
export const sanitizeName = (value, { trimEnd = false } = {}) => {
    let out = (value || '').replace(/\s/g, '-'); // each whitespace -> a dash

    // Keep trailing '-' while typing; trim only for submit/save if requested
    if (trimEnd) {
        out = out.replace(/-+$/, '');
    }

    return out;
};
